import { useEffect, useState } from "react";
import {
  onAuthStateChanged, signInWithEmailAndPassword, signOut, type User,
} from "firebase/auth";
import { auth } from "../firebase";

export interface AuthState {
  user: User | null;
  isAdmin: boolean;
  loading: boolean;
}

// Admin access is gated by a custom claim (admin=true) set by the grant-admin
// script. We read it from the ID token so security rules and the UI agree.
export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({ user: null, isAdmin: false, loading: true });

  useEffect(() => {
    return onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setState({ user: null, isAdmin: false, loading: false });
        return;
      }
      try {
        const token = await user.getIdTokenResult();
        setState({ user, isAdmin: token.claims.admin === true, loading: false });
      } catch (e) {
        console.error("Failed to read auth claims:", e);
        setState({ user, isAdmin: false, loading: false });
      }
    });
  }, []);

  return state;
}

export async function adminSignIn(email: string, password: string): Promise<void> {
  await signInWithEmailAndPassword(auth, email, password);
}

export async function adminSignOut(): Promise<void> {
  await signOut(auth);
}
